import { render, staticRenderFns } from "./ModificaCorsista.vue?vue&type=template&id=49c7de48&scoped=true&"
import script from "./ModificaCorsista.vue?vue&type=script&lang=js&"
export * from "./ModificaCorsista.vue?vue&type=script&lang=js&"
import style0 from "./ModificaCorsista.vue?vue&type=style&index=0&id=49c7de48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7de48",
  null
  
)

export default component.exports